import * as Sentry from '@sentry/tanstackstart-react'
import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  })

  if (!router.isServer) {
    Sentry.init({
      dsn: 'https://5177deec6e54fea89ecf2793f3c6a9d8@o1047077.ingest.us.sentry.io/4510680966561792',
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
      ],
      sendDefaultPii: true,
      enableMetrics: true,
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^\//],
    })
  }

  return router
}
